import { render, staticRenderFns } from "./FeatureV2.vue?vue&type=template&id=0fe358df&scoped=true&"
import script from "./FeatureV2.vue?vue&type=script&lang=js&"
export * from "./FeatureV2.vue?vue&type=script&lang=js&"
import style0 from "./FeatureV2.vue?vue&type=style&index=0&id=0fe358df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe358df",
  null
  
)

export default component.exports